export const category = [
    {cate:'Property for Sale', ic:require('../assests/propertysale.png')},
    {cate:'Property for Rent', ic:require('../assests/propertyrent.png')},
    {cate:'Vehicles', ic:require('../assests/vehicals.png')},
    {cate:'Bikes', ic:require('../assests/bike.png')},
    {cate:'Electronics And Home Appliances', ic:require('../assests/electronics.png')},
    {cate:'Mobiles', ic:require('../assests/mobile.png')},
    {cate:'Services', ic:require('../assests/services.png')},
    {cate:'Furniture And Home Decor', ic:require('../assests/furniture.png')},
    {cate:'Animals', ic:require('../assests/animals.png')},
    {cate:'Books And Sports', ic:require('../assests/books.png')},
    {cate:'Fashion And Beauty', ic:require('../assests/feshion.png')},
    {cate:'Kids', ic:require('../assests/kids.png')},
]


// WEBPACK FOOTER //
// ./src/config/category.js